import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {IUser, User} from '../../core/user/user.model';
import {UserService} from '../../core/user/user.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {CustomerService} from './customer.service';
import {CustomerDTO, ICustomerDTO} from '../../shared/model/customerDTO.model';
import {CustomerDTOService} from './customerDTO.service';
import * as moment from 'jalali-moment';
import {IEmployee} from "../../shared/model/employee.model";
import {EmployeeService} from "../../core/employee/employee.service";
import {AccountService} from "../../singelton/account.service";


@Component({
  selector: 'app-customer-assign-user-dialog',
  templateUrl: './customer-assign-user-dialog.component.html'
})
export class CustomerAssignUserDialogComponent implements OnInit {
  isSaving: boolean;
  @Input() customerId;
  @Input() customersSelected;
  user: IUser = new User();
  customerDTO: ICustomerDTO = new CustomerDTO();
  customer: ICustomer = new Customer();
  // customer: ICustomer = new Customer();

  employees: IEmployee[];
  users: User[];
  dateObject2: any;
  roles: any[] = [];
  roles2: String[] = [];

  userLogin: any;
  employeeId: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  showSelect = false;
  constructor(protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,
              protected userService: UserService, protected customerDTOService: CustomerDTOService,
              protected customerService: CustomerService,
              protected employeeService: EmployeeService,
              protected accountService: AccountService,

              private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'lastName',
      selectAllText: 'انتخاب همه',
      searchPlaceholderText: 'جستجو',
      unSelectAllText: 'هیچکدام',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    // alert(' in customersSelected ==' + this.customersSelected)
    this.isSaving = false;
    // this.loadCustomer();
    // this.loadCustomerDTO();
    // this.loadAllUsers();
    this.loadAllEmployee();

  }


  loadAllEmployee() {
    // alert(' load emplo');
    this.spinner.show();
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;

        for (let x = 0; x < this.employees.length; x++) {
          const temp = {id: this.employees[x].id, lastName: this.employees[x].lastName};
          this.dropdownList[x] = temp;
          // alert(' x== ' + x + ' dropdownList ==' + this.dropdownList.length);
        }
        this.showSelect = true;
        this.spinner.hide();

        // alert(' dropdownList ==' + this.dropdownList.length);

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadAllUsers() {
    // alert(' in load all users')
    this.spinner.show();
    this.userService
      .queryCustomerFilter({
        page: 0,
        size: 100,
      })
      .subscribe(
        (res: HttpResponse<User[]>) => this.onSuccessUsers(res.body, res.headers),
        (res: HttpResponse<any>) => this.onError(res.body)
      );


  }

  private onSuccessUsers(data, headers) {
    // alert(' onSuccessUsers')
    // this.links = this.parseLinks.parse(headers.get('link'));
    // this.totalItems = headers.get('X-Total-Count');
    // this.queryCount = this.totalItems;
    this.users = data;

    // for (let x = 0; x < this.authoritiesSelected.length; x++) {
    //   this.translate.get(this.authoritiesSelected[x]).subscribe((text: string) => {console.log(text);
    //     // alert(' text==' + text);
    //     const itemName = text;
    //     const temp = {id: this.authoritiesSelected[x], itemName: itemName};
    //     this.selectedItems[x] = temp;
    //
    //   });

    // }

    this.spinner.hide();
    // alert('this.users' + this.users)
  }

  checkValue(event: any, item: any) {
// alert('in this.customerDTO.users == ' +this.customerDTO.usersList);
//     // alert('this.roles' + this.roles)
//
//     if (event.currentTarget.checked) {
//       alert(' in check '+role_name);
//
//       this.customerDTO.usersList.push(role_name);
//     }
//     if (!event.currentTarget.checked) {
//       alert(' in check nist'+role_name);
//       this.roles = this.roles.filter(item => item !== role_name);
//
//       this.customerDTO.usersList = this.customerDTO.usersList.filter(item => item !== role_name);
//       alert(' in check nist'+this.customerDTO.usersList);
//
//     }
//     // this.customerDTO.usersList = this.roles;
//     this.customerDTO.usersId ='';
//     this.customerDTO.usersList.forEach((i) =>
//     {
//       this.customerDTO.usersId = this.customerDTO.usersId  + ',' + i;
//     })
//     alert(' 222222222222222222in this.customerDTO.users == ' +this.customerDTO.usersId);
//
//     alert('this.customerDTO.usersList' +this.customerDTO.usersList)

    if(event.currentTarget.checked) {
      // alert('44444444'+ item)
      // alert('44444444'+ this.roles2.indexOf(item+''))
      // channelArray.includes('three'); //will return true or false
        if(this.roles2.indexOf(item+'') !== -1) {
        } else {
          this.roles2.push(item);

        }
    }
    if(!event.currentTarget.checked) {
      //this.authorities.forEach( auth => { if(auth === item)
      // alert('this.roles2== ' + this.roles2);
      this.roles2 = this.roles2.filter(i => i !== item+'');
    }
    // alert('222222222222222222222this.roles2== ' +this.roles2);

  }

  loadCustomer() {
    alert(' in load customer'+this.customerId);
    this.customerService.find(this.customerId).subscribe(
      (res: HttpResponse<ICustomer>) => {
        this.customer = res.body;
        const jalaliDate5 = moment(this.customer.jalaliDate).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
        this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadCustomerDTO() {
    alert(' in load customer' + this.customerId);
    this.customerDTOService.find(this.customerId).subscribe(
      (res: HttpResponse<ICustomer>) => {
        this.customerDTO = res.body;
        // alert(' this.customerDTO==' + this.customerDTO);
        // alert(' this.customerDTO.users==' + this.customerDTO.usersId);

        this.customerDTO.usersList.forEach((c) => {
          // alert(' c==' + c);
          this.roles2.push(c);

        });
        // alert(' this.roles==' + this.roles);
        // if(this.customerDTO.users.includes(val)) {
        //   // alert('item -- ' + item);
        //   // alert('this.roles  before-- ' + this.roles)
        //   if(!this.roles.includes(item)) {
        //     this.roles.push(item);
        //     // alert('this.roles -- ' + this.roles)
        //   }
        // }
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  save() {
    this.spinner.show();


    // this.customersSelected.forEach(c => {
      // alert('cc= ' + c.toString());
      // const employee_list: IEmployee[] = this.customer.employees;

      // this.customerService.findByIdWithEmId(c.toString()).subscribe(
      //   (res: HttpResponse<ICustomer>) => {
      //     this.customer = res.body;
      //     this.customer.employees = employee_list;
      this.customer.assign_list = this.customersSelected+'';
          this.subscribeToSaveResponseUpdate2(this.customerService.assign(this.customer));

        // },
        // (res: HttpErrorResponse) => this.onError(res.message)
      // );

      // this.customer = new Customer(c.toString());

    // });
  }
  save_before() {
    this.spinner.show();


    // this.customersSelected.forEach(c=>{
    //  // alert('cc= '+ c.toString());
    //  const employee_list:IEmployee[] = this.customer.employees;
    //  this.customer = new Customer(c.toString());
    //  this.customer.employees =employee_list;
    //   this.subscribeToSaveResponseUpdate2(this.customerService.update(this.customer));
    //
    // });



    // alert(' in save userLogin' + this.userLogin);
    // alert(' in save ' +this.user.login);
    // user :User = new User(5);
    const span_actionDate2 = document.getElementById('span_actionDate2');
    // alert(' span_actionDate2 ==' +span_actionDate2);

    if (!this.customerId) {
      // alert(' in if ')
      this.userService.find(this.userLogin).subscribe(
        (res: HttpResponse<IUser>) => {
          this.user = res.body;
          if (span_actionDate2) {
            this.user.jalaliDate = (<HTMLInputElement>span_actionDate2).innerHTML;
            // alert(' this.user.jalaliDate ==' + this.user.jalaliDate);
          }

          // alert('this.customersSelected==' + this.customersSelected.length);
          this.user.customers = this.customersSelected;
          // alert('this.user.customers ==' + this.user.customers.length);
          this.userService.update(this.user).subscribe(response => this.onSaveSuccessUser(response), (rej) => this.onSaveErrorUser(rej));

        });

    } else if (this.customerId) {
      // alert(' in else ' + this.roles2);
      this.customerDTO.id = this.customer.id;
      this.customerDTO.usersList = this.roles2;
      // alert('this.customerDTO.usersList==' + this.customerDTO.usersList)
      if (span_actionDate2) {
        this.customerDTO.jalaliDate = (<HTMLInputElement>span_actionDate2).innerHTML;
        // alert(' this.transaction.actionDate ==' + this.transaction.audience);
      }

      this.customerDTO.users = '1';
//alert(' this.user.extAuthorities  == ' +this.user.extAuthorities );
//       if (this.user.id !== null) {
      if (this.customer.id !== undefined) {
        this.subscribeToSaveResponseUpdate(this.customerDTOService.update(this.customerDTO));
      }

      // this.customerService.update(this.customer).subscribe(response => this.onSaveSuccess(response), (rej) => this.onSaveError(rej));
      // } else {
      // this.customerService.createUserWithPassword(this.customer)
      //   .subscribe(response => this.onSaveSuccess(response), (rej) => this.onSaveError(rej));
      // }

    }
  }
  protected subscribeToSaveResponseUpdate2(result: Observable<HttpResponse<ICustomer>>) {
    result.subscribe((res: HttpResponse<ICustomer>) => this.onSaveSuccessUpdate(res), (res: HttpErrorResponse) => this.onSaveError());
  }


  protected subscribeToSaveResponseUpdate(result: Observable<HttpResponse<ICustomerDTO>>) {
    result.subscribe((res: HttpResponse<ICustomerDTO>) => this.onSaveSuccessUpdate(res), (res: HttpErrorResponse) => this.onSaveError());
  }


  checkUsersValue(item) {

    // alert(' in chhhhhh');
    // alert(' in chhhhhh this.customerDTO.usersList==' + this.customerDTO.usersId);
    // alert('return this.customerDTO.users.includes(val) '+ this.customerDTO.users.includes(val));
//   if(this.customerDTO.users.includes(val)) {
//     // alert('item -- ' + item);
//     // alert('this.roles  before-- ' + this.roles)
// if(!this.roles.includes(item)) {
//   this.roles.push(item);
//   // alert('this.roles -- ' + this.roles)
// }
//   }
//     const reVar = false;
//     this.customerDTO.usersList.forEach((u) => {
//       alert('u==' + u);
      // alert('item==' + item);
      // if (u + '' === item + '') {
      //   alert(' in if item==' + item + 'u==' + u);
      //   return true;
      //   reVar = true;
      //   break;
      // } else {
      //   reVar = false;
      // }
    // })
    // return reVar;
    // return this.roles2.includes(item+'');

  }

  protected onSaveSuccessUpdate(res) {
    // alert(' res ==' + res);
    // this.customer = res.body;
    // alert(' this.cusotmer === ' + this.customer.id)
    // this.isSaving = false;
    this.clear();
    this.spinner.hide();

    // this.toastr.success('     ثبت تغييرات با موفقیت انجام شد.     ', '   کاربر گرامی!    ');

    // this.previousState();
    // this.jhiAlertService.info('ثبت تغییرات با موفقیت انجام شد.', null, null);
  }

  private onSaveSuccessUser(result) {
    this.clear();
    this.spinner.hide();
  }

  private onSaveErrorUser(rej: any) {
  }


  previousState() {
    window.history.back();
  }

  //

  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
